"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnreachableCaseError = void 0;
class UnreachableCaseError extends Error {
    constructor(variant, message) {
        super(`Unhandled ${JSON.stringify(variant)}: ${message}`);
    }
}
exports.UnreachableCaseError = UnreachableCaseError;
//# sourceMappingURL=unreachable-case-error.js.map